// extracted by mini-css-extract-plugin
export default {"main":"CreateLoanProgramPage_main__qSCP5"};